import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { GenTabParagraphContainerComponent } from './tab-paragraph-container.component';
import { OutletModule, PageComponentModule } from "@spartacus/storefront";
import { GenEnergyManagementSystemComponent } from '../../shared/components/energy-management-system/energy-management-system.component';
import { GenInfoMessageComponent } from '../../shared/components/info-message/info-message.component';

@NgModule({
  imports: [CommonModule, PageComponentModule, OutletModule, I18nModule, GenInfoMessageComponent, GenEnergyManagementSystemComponent],
  declarations: [GenTabParagraphContainerComponent],
  exports: [GenTabParagraphContainerComponent],
})
export class GenTabParagraphContainerModule {}
